import { useCallback, useSyncExternalStore } from 'react'

/**
 * Ekran sorgusu kancası — CSS kırılımlarının JS karşılığı.
 *
 * Ne İÇİN: yerleşimi `@media` çözer, bu kanca DAVRANIŞ çatalı içindir. Örneğin
 * imleç koordinatına açılan balonun mobilde alttan çıkan panele dönmesi
 * (Faz 2) — aynı bileşen, farklı kap; bunu CSS ile ifade etmek mümkün değil.
 * Sırf görünüm için kullanılırsa iki ayrı doğruluk kaynağı oluşur.
 *
 * `useSyncExternalStore` bilinçli: `useState` + `useEffect` ile yazılsaydı ilk
 * boyama varsayılan değerle yapılır, ölçüm ardından ikinci bir boyama gelirdi —
 * kullanıcı masaüstü düzenin bir kare görünüp mobile atlamasını görürdü.
 */

/** `styles.css`teki `@media (max-width: 767px)` ile BİREBİR aynı olmalı. */
export const MOBIL_ESIK = 767

const MOBIL_SORGU = `(max-width: ${MOBIL_ESIK}px)`

/**
 * Sorgu başına tek `MediaQueryList`. Her çağrıda yenisini kurmak da çalışırdı
 * ama `useSyncExternalStore` anlık değeri sık sık okur; nesneyi paylaşmak hem
 * ucuz hem de abone/anlık okuma çiftinin aynı listeye bakmasını garantiliyor.
 */
const listeler = new Map<string, MediaQueryList>()

function medya(query: string): MediaQueryList {
  let mq = listeler.get(query)
  if (!mq) {
    mq = window.matchMedia(query)
    listeler.set(query, mq)
  }
  return mq
}

export function useMediaQuery(query: string): boolean {
  // İki geri çağrı da `useCallback` ile sabitleniyor: `useSyncExternalStore`
  // abone fonksiyonu her render'da değişirse aboneliği bozup yeniden kuruyor.
  const abone = useCallback(
    (bildir: () => void) => {
      const mq = medya(query)
      mq.addEventListener('change', bildir)
      return () => mq.removeEventListener('change', bildir)
    },
    [query],
  )

  const anlik = useCallback(() => medya(query).matches, [query])

  // Üçüncü argüman sunucu tarafı render içindir; bu uygulamada yok, imza gereği
  // duruyor ve masaüstü varsayıyor.
  return useSyncExternalStore(abone, anlik, () => false)
}

/** Telefon genişliği mi? */
export function useIsMobile(): boolean {
  return useMediaQuery(MOBIL_SORGU)
}
